import type { RichTextField } from '@/types/prismic'
import { hasText } from '@/utils/prismicUtilityFunction'

/**
 * Extracts raw HTML from a Prismic CustomCode `code_contents` field.
 *
 * Security: CustomCode slices render editor-supplied HTML via `dangerouslySetInnerHTML`.
 * Content is authored in Prismic by trusted staff only; sanitization is intentionally
 * omitted so embeds (iframes, scripts, third-party widgets) continue to work.
 * XSS risk is limited to compromised CMS credentials — restrict Prismic write access.
 *
 * @see docs/security/dangerously-set-inner-html-policy.md — full inventory
 *
 * @see src/components/blog/CustomCode.tsx — renders HTML and re-executes
 *   embedded <script> tags after hydration via useEffect
 */
export function getCustomCodeHtml(field: RichTextField | null | undefined): string {
  if (!field?.length) return ''

  const first = field[0]
  if (typeof first === 'string') return first
  if (hasText(first)) return first.text

  return ''
}
